import React, { useState, useRef, useEffect } from "react";
import { Tooltip } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import moment from "moment";
import { Icons } from "../../../../assets";
import SearchIcon from "@mui/icons-material/Search";
import classNames from "classnames";
import CheckboxSelector from "../../../Schedules/components/CheckboxSelector";

function PatientZipcodeReportTable(
  {
    patientzipcodeReports,
    setPatientZipcodeReports,
    selectedZipcodes,
    zipCodes,
    isSelectAllZipcodes,
    setIsSelectAllZipcodes,
    handleZipcodeFilter,
    filteredPt,
    setFilteredPt,
    getPatientsByZip
  })
  {
    const TABLE_HEADERS = [
      "Zip code",
      "No. of Patients",
    ];
    const [isDisAse, setIsDisAse] = React.useState(true);
    const [zipCodeListOpen, setZipCodeListOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [patientNameSearch, setPatientNameSearch] = React.useState("");
    const DAY_MAP = {
      MONDAY: "M",
      TUESDAY: "T",
      WEDNESDAY: "W",
      THURSDAY: "Th",
      FRIDAY: "F",
      SATURDAY: "Sa",
      SUNDAY: "Su",
    };
    const parseNull = (value, replacement = "NA", type = "string") => {
      return value === null || (Array.isArray(value) && value.length === 0)
          ? replacement
          : Array.isArray(value)
          ? value.map((day) => DAY_MAP[day]).join(",")
          : type === "date"
              ? moment(value).format("MM/DD/YYYY")
              : value;
    };
    const handleZipcodeListOpen = () => {
      setZipCodeListOpen(!zipCodeListOpen);
      if (zipCodeListOpen) {
      setPatientNameSearch("");
      setFilteredPt(zipCodes);
    }
    };
    const handleSelectAllZipcodes = () => {
      handleZipcodeFilter(-1, {
        selectAll: true,
        isSelectAll: !isSelectAllZipcodes,
      });
      setIsSelectAllZipcodes(!isSelectAllZipcodes);
    };
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setZipCodeListOpen(false);
        setPatientNameSearch("");
        setFilteredPt(zipCodes);
      }
    };
    React.useEffect(() => {
      if (zipCodeListOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      } else {
        document.removeEventListener("mousedown", handleClickOutside);
      }
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [zipCodeListOpen]);
    React.useEffect(() => {
      setIsDisAse(true);
      selectedZipcodes.length === zipCodes.length
        ? setIsSelectAllZipcodes(true)
        : setIsSelectAllZipcodes(false);
    }, [selectedZipcodes]);
    return (
      <>
        <div className="h-full overflow-auto mt-2 w-full">
          <table
            className="w-full"
            style={{ whiteSpace: "nowrap" }}
            id="providerZipcodeReport"
          >
            <thead>
              <tr className="bg-primarylightgrey">
                {TABLE_HEADERS.map((header, index) => {
                  if (header === "Zip code") {
                    return (
                      <th
                        key={index}
                        className={
                          "py-3 text-base relative min-w-56 " +
                          (selectedZipcodes.length > 0 || zipCodeListOpen
                            ? "bg-highlight"
                            : "")
                        }
                        ref={dropdownRef}
                      >
                        <div className="flex flex-row  justify-center items-center">
                          <p className="m-0">
                            {header}
                            <span className="dropdown-icon ml-3"></span>
                          </p>
                          <Tooltip title="Sort">
                            <button
                              className="pr-2"
                              onClick={handleZipcodeListOpen}
                            >
                              <img
                                src={Icons.Sort_Icon}
                                alt="search"
                                className="w-5 h-5 cursor-pointer search-icon"
                              />
                            </button>
                          </Tooltip>{" "}
                          {zipCodeListOpen && (
                            <div className="absolute z-50 flex flex-col w-full overflow-auto no-scrollbar bg-white border  max-h-52 top-16">
                              <div className="d-flex align-center sticky top-0 bg-white">
                                <input
                                  type="search"
                                  value={patientNameSearch}
                                  onChange={(e) => {
                                    setPatientNameSearch(e.target.value);
                                    setFilteredPt(
                                      zipCodes.filter((zipcode) => {
                                        return zipcode
                                          .toLowerCase()
                                          .includes(
                                            e.target.value.toLowerCase()
                                          );
                                      })
                                    );
                                  }}
                                  className="search-input"
                                  autoFocus
                                  placeholder="Search"
                                />
                                {patientNameSearch === "" ? (
                                  <SearchIcon className="zip-search-icon-input" />
                                ) : (
                                  ""
                                )}
                              </div>
                              {filteredPt.length > 0 ? (
                                <>
                                  <th
                                    className={classNames(
                                      "px-4 py-3 cursor-pointer text-sm"
                                    )}
                                  >
                                    <label className="flex flex-row items-center gap-2 cursor-pointer">
                                      <input
                                        type="checkbox"
                                        className="w-4 h-4 checked:lightblue"
                                        checked={
                                          isSelectAllZipcodes ||
                                          selectedZipcodes.length ===
                                          zipCodes.length
                                        }
                                        onChange={(e) => {
                                          handleSelectAllZipcodes();
                                        }}
                                      />
                                      <p
                                        className={classNames(
                                          "m-0 cursor-pointer text-sm font-bold"
                                        )}
                                      >
                                        Select All
                                      </p>
                                    </label>
                                  </th>
                                  {filteredPt.map((zipcode, index) => (
                                    <div
                                      className={classNames(
                                        "hover:bg-primarylightgrey",
                                        zipCodes.length - 1 && "border-b"
                                      )}
                                    >
                                      <CheckboxSelector
                                        header={zipcode}
                                        isChecked={
                                          selectedZipcodes.includes(zipcode)
                                            ? true
                                            : false
                                        }
                                        handleChange={(_e) =>
                                          handleZipcodeFilter(zipcode, {
                                            selectAll: false,
                                            isSelectAll: !isSelectAllZipcodes,
                                          })
                                        }
                                        isBold={false}
                                      />
                                    </div>
                                  ))}
                                </>
                              ) : (
                                <div className="no-record-found">
                                  No Zipcodes Found
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </th>
                    );
                  }
                  else if (header === "No. of Patients") {
                    return (
                      <th
                        key={index}
                        className="px-2 py-3 text-base min-w-52 d-flex justify-center"
                      >
                        <div className="d-flex flex-row  items-center justify-center relative">
                          <div className="d-flex align-items-center w-full justify-center">
                            <p className="m-0">{header}</p>
                            {isDisAse ? (
                              <Tooltip title="Sort Descending">
                                <ArrowDropUpIcon
                                  style={{
                                    fontSize: 30,
                                    color: "#212529",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => {
                                    setIsDisAse(false);
                                    const result = [...patientzipcodeReports].sort(
                                      (a, b) =>
                                        new Date(a.patientCount) -
                                        new Date(b.patientCount)
                                    );
                                    setPatientZipcodeReports(result);
                                  }}
                                  value="asc"
                                  className="arrow-up"
                                />
                              </Tooltip>
                            ) : (
                              <Tooltip title="Sort Ascending">
                                <ArrowDropDownIcon
                                  style={{
                                    fontSize: 30,
                                    color: "#212529",
                                    cursor: "pointer",
                                  }}
                                  value="des"
                                  className="arrow-down"
                                  onClick={() => {
                                    setIsDisAse(true);
                                    const result = [...patientzipcodeReports].sort(
                                      (a, b) =>
                                        new Date(b.patientCount) -
                                        new Date(a.patientCount)
                                    );
                                    setPatientZipcodeReports(result);
                                  }}
                                />
                              </Tooltip>
                            )}
                          </div>
                        </div>
                      </th>
                    );
                  }
                  else {
                    return (
                      <th key={index} className="px-2 py-3 text-base">
                        <div className="flex flex-row justify-center items-center">
                          <p className="m-0">{header}</p>
                        </div>
                      </th>
                    );
                  }
                })}
              </tr>
            </thead>
            {patientzipcodeReports.length > 0 ? (
              <tbody>
                {patientzipcodeReports.map((provider, index) => {
                  const isEven = (index + 1) % 2 === 0;
                  return (
                    <tr
                      className={`text-base border-bottom  text-gray-900 border-bottom ${isEven ? "bg-primarylightgrey" : ""
                        }`}
                    >
                      <td className="px-2 py-3">
                        {parseNull(provider.zipCode)}
                      </td>
                      <td className="px-2 py-3 align-items-center">
                        {/* {parseNull(provider.patientCount)} */}
                         <span
                          className="relative inline-block cursor-pointer hover:text-[#3962d4] hover:font-semibold
                          after:content-[''] after:absolute after:left-[-25%] after:-bottom-0.5
                          after:w-[180%] after:h-[2px] after:bg-[#3962d4] after:scale-x-0
                          hover:after:scale-x-100 after:transition-transform after:duration-300"
                           onClick={() => getPatientsByZip(provider.zipCode)}
                        >
                          {parseNull(provider.patientCount)}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <div
                  className="d-flex align-items-center justify-content-center absolute w-full my-5 py-3"
                  style={{ zIndex: 0 }}
                >
                  <p className="text-xl font-bold text-primarygrayborder">
                    {" "}
                    No Records Found
                  </p>
                </div>
              </tbody>
            )}
          </table>
        </div>
      </>
    );
  }

export default PatientZipcodeReportTable;